import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Save, UserPlus, X, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

export const SignupNudge = ({ 
    isVisible, 
    onSignUp, 
    onDismiss,
    blueprintName 
}) => {
    if (!isVisible) return null;

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0, y: 20, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -20, scale: 0.95 }}
                transition={{ type: "spring", damping: 20, stiffness: 300 }}
                className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 w-full max-w-md px-4"
                data-testid="signup-nudge"
            >
                <div className="bg-gradient-to-r from-violet-900/95 to-fuchsia-900/95 backdrop-blur-xl border border-violet-500/30 rounded-2xl p-5 shadow-2xl shadow-violet-500/20">
                    {/* Close button */}
                    <button
                        onClick={onDismiss}
                        className="absolute top-3 right-3 text-zinc-400 hover:text-white transition-colors"
                        aria-label="Dismiss"
                    >
                        <X className="w-4 h-4" />
                    </button>

                    {/* Icon and title */}
                    <div className="flex items-start gap-3 mb-4">
                        <div className="p-2 bg-violet-500/20 rounded-lg">
                            <Save className="w-5 h-5 text-violet-300" />
                        </div>
                        <div>
                            <h3 className="font-semibold text-white text-lg">
                                Save this blueprint?
                            </h3>
                            <p className="text-sm text-zinc-300 mt-1">
                                Create a free account to save your blueprints and revisit them later.
                            </p>
                        </div>
                    </div>

                    {/* Blueprint preview */}
                    {blueprintName && (
                        <div className="bg-zinc-900/50 rounded-lg p-3 mb-4 flex items-center gap-2">
                            <Sparkles className="w-4 h-4 text-amber-400" />
                            <span className="text-sm text-zinc-300 truncate">
                                {blueprintName}
                            </span>
                        </div>
                    )}

                    {/* Action buttons */}
                    <div className="flex gap-3">
                        <Button
                            data-testid="signup-nudge-signup-btn"
                            onClick={onSignUp}
                            className="flex-1 bg-violet-600 hover:bg-violet-500 text-white font-medium py-2.5"
                        >
                            <UserPlus className="w-4 h-4 mr-2" />
                            Sign Up to Save
                        </Button>
                        <Button
                            data-testid="signup-nudge-dismiss-btn"
                            variant="outline"
                            onClick={onDismiss}
                            className="bg-zinc-800/50 border-zinc-600 text-zinc-300 hover:bg-zinc-700/50 py-2.5"
                        >
                            Continue
                        </Button>
                    </div>

                    {/* Subtle benefit text */}
                    <p className="text-xs text-zinc-500 text-center mt-3">
                        Free forever. No credit card required.
                    </p>
                </div>
            </motion.div>
        </AnimatePresence>
    );
};

export default SignupNudge;
